import { TextField } from '@mui/material';
import { InterviewInputProps } from '../types';

export const InterViewTextField = (props: InterviewInputProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.sub) {
      props.onChange({
        id: props.id,
        sub: {
          text: e.target.value
        }
      });
    } else {
      props.onChange({ id: props.id, text: e.target.value });
    }
  };

  if (props.sub) {
    return (
      <TextField
        type="text"
        fullWidth
        size="small"
        value={(props.answers?.sub && props.answers.sub.text) ?? ''}
        onChange={handleChange}
        sx={{ backgroundColor: '#fff', marginTop: '4px !important' }}
      />
    );
  } else {
    return (
      <TextField
        type="text"
        fullWidth
        size="small"
        value={(props.answers && props.answers.text) ?? ''}
        onChange={handleChange}
        sx={{ backgroundColor: '#fff', marginTop: '4px !important' }}
      />
    );
  }
};
